<template>
    <div ref="zoom_up"></div>
</template>

<script>
import ZoomUp from "!!raw-loader!../../assets/ricoh_assets/icons/ICN004-03_zoom_up.svg" // loads SVG Icons as String via Webpack.
export default {
    mounted() {
        let shadowRoot = this.$refs.zoom_up.attachShadow({mode: 'open'})
        shadowRoot.innerHTML = ZoomUp

        const style = document.createElement('style')
        style.innerHTML = `svg { width: 100%; height: 100%; }`

        const clonedStyle = style.cloneNode(true)
        shadowRoot.appendChild(clonedStyle)
    }
}
</script>

<style>

</style>